import { render, staticRenderFns } from "./Packages.vue?vue&type=template&id=16dc37c4&scoped=true"
import script from "./Packages.vue?vue&type=script&lang=js"
export * from "./Packages.vue?vue&type=script&lang=js"
import style0 from "./Packages.vue?vue&type=style&index=0&id=16dc37c4&prod&lang=scss&scoped=true"
import style1 from "./Packages.vue?vue&type=style&index=1&id=16dc37c4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dc37c4",
  null
  
)

export default component.exports